import React from "react";
import {
  CreditsContainer,
  SmallHeading,
  StackedWrapper,
} from "../styles/components/Galleries/Global";
import ImageDisplay from "./Image";

const GalleryStacked = ({
  direction = "right",
  src,
  mobile,
  credits = "Credits",
}) => {
  return (
    <StackedWrapper
      $flex
      $direction={direction === "right" ? "row" : "row-reverse"}
    >
      <ImageDisplay src={src} mobile={mobile} />
      <CreditsContainer
        $justify={direction === "right" ? "flex-start" : "flex-end"}
      >
        <SmallHeading>{credits}</SmallHeading>
      </CreditsContainer>
    </StackedWrapper>
  );
};

export default GalleryStacked;
